import React from 'react';

import { Button, Group, Stack, Text } from '@mantine/core';
import useDeleteLocation from 'hooks/location/useDeleteLocation';
import { Location } from 'types';
import notificationHandler from 'utils/notifications';

interface IDeleteLocationModalProps {
  location: Location;
  handleClose: () => void;
}

const DeleteLocationModal = ({ location, handleClose }: IDeleteLocationModalProps): JSX.Element => {
  const deleteLocationMutation = useDeleteLocation();

  const handleDelete = (): void => {
    const { successNotification, errorNotification } = notificationHandler();
    deleteLocationMutation.mutate(location.locationId, {
      onSuccess: () => {
        successNotification('Location delete success', `${location.name} successfully deleted.`);
        handleClose();
      },
      onError: error => {
        errorNotification('Location delete failed', error.response?.data.message);
      },
    });
  };

  return (
    <Stack>
      <Text>{`Are you sure you want to delete ${location.name}?`}</Text>
      <Text color='dimmed'>This action cannot be undone.</Text>
      <Group position='right'>
        <Button onClick={handleDelete} color='red' loading={deleteLocationMutation.isLoading}>
          Delete
        </Button>
      </Group>
    </Stack>
  );
};

export default DeleteLocationModal;
